<template>
  <ModalCard>
    <template #custom>
      <div
        class="is-flex is-flex-direction-column custom-body is-align-items-center custom-body py-5"
      >
        <div class="has-text-primary self-center is-size-2 has-text-weight-semibold">
          <span>{{ $t('Share the gift of a will') }}</span>
        </div>
        <div class="m-l-20">
          <img src="@/assets/illustrations/gift-box-colour.svg" width="80%" />
        </div>
        <div>
          <p class="is-size-6 has-text-centered message">
            {{ $t('platformreferral.gift-box-description') }}
          </p>
        </div>
        <template v-if="platformReferral">
          <DesktopReferralOptions
            :class="{ 'is-hidden-touch': isWebShareApiSupported }"
            :referral-link="referralLink"
          />
          <MobileReferralOption
            v-if="isWebShareApiSupported"
            class="is-hidden-desktop"
            :referral-link="referralLink"
          />
        </template>
        <LoadingView v-else :active="true" :is-full-page="false" />
        <CopyReferralLink :referral-link="referralLink" />
      </div>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '/@/modules/core/ui/components/ModalCard.vue';
import CopyReferralLink from '/@/modules/platformreferral/components/CopyReferralLink.vue';
import { ModalMixin } from '/@/modules/core/ui/mixins/ModalMixin';
import DesktopReferralOptions from '/@/modules/platformreferral/components/DesktopReferralOptions.vue';
import PlatformReferralService from '/@/modules/platformreferral/services/PlatformReferralService';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import ReferralPageUrlService from '/@/modules/platformreferral/services/ReferralPageUrlService';
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import MobileReferralOption from '/@/modules/platformreferral/components/MobileReferralOption.vue';
import LoadingView from '@/modules/core/ui/components/wrappers/LoadingView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FreeWillReferralModal',
  mixins: [ModalMixin, HasAuthUserMixin],
  components: {
    MobileReferralOption,
    DesktopReferralOptions,
    CopyReferralLink,
    ModalCard,
    LoadingView
  },
  static: {
    isWebShareApiSupported: !!navigator.share
  },
  data() {
    return {
      platformReferral: null
    };
  },
  computed: {
    referralLink() {
      return ReferralPageUrlService.getUrl(this.platformReferral?.referralId);
    }
  },
  methods: {
    async loadPlatformReferral() {
      const platformReferrals = await PlatformReferralService.getEntities({
        modelType: ModelType.USER,
        modelId: this.authUser.id
      });

      this.platformReferral = platformReferrals[0];
    }
  },
  created() {
    this.loadPlatformReferral();
  }
};
</script>

<style scoped>
.custom-body {
  gap: var(--ce-20px);
}

.message {
  max-width: var(--ce-220px);
}

.close-modal.is-absolute {
  right: var(--ce-5px);
  top: var(--ce-5px);
}
</style>
